import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { applyTheme, getStoredTheme, setTheme, type Theme } from "../lib/theme";
import GuardSettings from "../components/GuardSettings";

export default function Profile() {
  const navigate = useNavigate();
  const [theme, setLocal] = useState<Theme>(getStoredTheme());

  function choose(t: Theme) {
    setLocal(t);
    setTheme(t);
    applyTheme(t);
  }

  return (
    <div className="max-w-2xl mx-auto p-4 sm:p-6 space-y-6">
      <header className="flex items-center gap-3">
        <button onClick={() => navigate("/")} className="btn-secondary">←</button>
        <h1 className="text-2xl font-semibold flex-1">Profile</h1>
      </header>

      <section className="card-surface p-4 space-y-3">
        <div className="text-xs uppercase tracking-wide text-slate-500">Theme</div>
        <div className="flex gap-2">
          {(["light", "dark"] as Theme[]).map((t) => (
            <button
              key={t}
              type="button"
              onClick={() => choose(t)}
              className={theme === t ? "btn-primary" : "btn-secondary"}
              aria-pressed={theme === t}
            >
              {t === "light" ? "Light" : "Dark"}
            </button>
          ))}
        </div>
      </section>

      <GuardSettings />
    </div>
  );
}
